module.exports = __webpack_public_path__ + "img/whoIsBest.84c5e044.gif";